
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newsletters/[slug]",
      function () {
        return require("private-next-pages/newsletters/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/newsletters/[slug]"])
      });
    }
  